import React, { useEffect, useRef, useState } from 'react';
import customerApi from '../../api';
import contractorApi from '../../contractorApi';

const BellIcon = ({ hasUnread }) => (
    <div style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
        {hasUnread && (
            <span style={{
                position: 'absolute', top: -3, right: -3,
                width: 9, height: 9, borderRadius: '50%',
                background: '#e53935', border: '1.5px solid #fff',
            }} />
        )}
    </div>
);

const timeAgo = (dateStr) => {
    const diff = (Date.now() - new Date(dateStr).getTime()) / 1000;
    if (diff < 60) return 'たった今';
    if (diff < 3600) return `${Math.floor(diff / 60)}分前`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}時間前`;
    return `${Math.floor(diff / 86400)}日前`;
};

const NotificationBell = ({ userType, userId }) => {
    const [notifications, setNotifications] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const api = userType === 'contractor' ? contractorApi : customerApi;

    const fetchNotifications = () => {
        if (!userId) return;
        api.get(`notifications/${userType}/${userId}`)
            .then(r => setNotifications(r.data))
            .catch(console.error);
    };

    useEffect(() => {
        fetchNotifications();
        const timer = setInterval(fetchNotifications, 15000);
        return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userType, userId]);

    // ドロップダウン外クリックで閉じる
    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    const handleOpen = async () => {
        setIsOpen(prev => !prev);
        // 開いたら全既読
        const unread = notifications.filter(n => !n.is_read);
        if (unread.length > 0) {
            await api.post('notifications/mark_all_read', { user_type: userType, user_id: userId });
            setNotifications(prev => prev.map(n => ({ ...n, is_read: true })));
        }
    };

    const handleClick = (n) => {
        setIsOpen(false);
        if (n.project_id) {
            const path = userType === 'customer'
                ? `/customer/chat/${n.project_id}`
                : `/contractor/project/${n.project_id}`;
            window.location.href = path;
        }
    };

    const hasUnread = notifications.some(n => !n.is_read);

    return (
        <div ref={ref} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            <button
                onClick={handleOpen}
                style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    padding: '4px 6px', display: 'flex', alignItems: 'center',
                }}
                aria-label="通知"
            >
                <BellIcon hasUnread={hasUnread} />
            </button>

            {isOpen && (
                <div style={{
                    position: 'absolute', top: '110%', right: 0,
                    width: 300, maxHeight: 400, overflowY: 'auto',
                    background: '#fff', borderRadius: 4,
                    boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                    zIndex: 9999,
                    border: '1px solid #e0e0e0',
                }}>
                    <div style={{
                        padding: '10px 14px', fontWeight: 600, fontSize: '0.85rem',
                        borderBottom: '1px solid #f0f0f0', color: '#333',
                        background: '#fafafa',
                    }}>
                        通知
                    </div>

                    {notifications.length === 0 ? (
                        <div style={{ padding: '20px 14px', color: '#aaa', fontSize: '0.85rem', textAlign: 'center' }}>
                            通知はありません
                        </div>
                    ) : (
                        notifications.map(n => (
                            <div
                                key={n.id}
                                onClick={() => handleClick(n)}
                                style={{
                                    padding: '10px 14px',
                                    borderBottom: '1px solid #f5f5f5',
                                    cursor: n.project_id ? 'pointer' : 'default',
                                    background: n.is_read ? '#fff' : '#f0f7f6',
                                }}
                            >
                                <div style={{ fontSize: '0.85rem', color: '#1a1a1a', lineHeight: 1.4 }}>
                                    {n.message}
                                </div>
                                <div style={{ fontSize: '0.72rem', color: '#aaa', marginTop: 3 }}>
                                    {timeAgo(n.created_at)}
                                </div>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default NotificationBell;
